import { useIsMobileDevice } from "@src/appV2/redesign/AppLayout/useResponsive";

import { useIsHomeHealthWorkplaceMobileExperienceEnabled } from "./useIsHomeHealthWorkplaceMobileExperienceEnabled";

export type HomeHealthSurface = "mobile" | "desktop";

// The HH surface the user is in, for tagging analytics events. Uses the same
// inputs as the route-level mobile/desktop split so it can't drift from it.
export function useHomeHealthSurface(): HomeHealthSurface {
  const isMobileDevice = useIsMobileDevice();
  const isMobileExperienceEnabled = useIsHomeHealthWorkplaceMobileExperienceEnabled();

  return isMobileDevice && isMobileExperienceEnabled ? "mobile" : "desktop";
}
